import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {autoSubmitForm} from "./common/auto-submit-form";

export const OciApproval = ({disabled, cart, next}) => cs(
    ["itemOci", (_, next) => next(disabled ? null : cart.items.find((i) => i.approvalInfo?.approvalType === "oci")?.approvalInfo)],
    consumeContext("apis"),
    ({itemOci, apis}) => {
        return next(!itemOci ? (
            null
        ) : {
            error: itemOci.hookUrl ? null : {
                message: "Your order cannot be submitted to your SRM system. Please return to your SRM system and open a new session",
            },
            submitRequest: async () => {
                const ociForm = await apis.next.approval.getOciForm(cart.cartId);
                autoSubmitForm(ociForm.ociForm);
            },
        });
    },
);

